export default __webpack_public_path__ + "static/media/loading-error.91556b2e.svg";